import { useIsDevCycleInitialized } from '@devcycle/react-client-sdk';
import { type JSX, lazy, Suspense } from 'react';
import Layout from '@/components/Layout/Layout';
import Loader from '@/components/Loader/Loader';
import { type Country, getConfig } from '@/constants/config';
import useFeatureFlag from '@/featureFlags/useFeatureFlag';

const countryComponents = {
  SE: lazy(() => import('@/routes/Pages/country/SE/SE')),
  UK: lazy(() => import('@/routes/Pages/country/UK/UK')),
  FI: lazy(() => import('@/routes/Pages/country/FI/FI')),
} satisfies Record<Country, React.LazyExoticComponent<() => JSX.Element>>;

const PagesComponent = countryComponents[getConfig().country];

const Maintenance = lazy(() => import('@/pages/Maintenance/Maintenance'));

const Pages = () => {
  const isMaintenanceInProgress = useFeatureFlag('maintenanceInProgress');
  if (!useIsDevCycleInitialized()) {
    return <Loader />;
  }

  if (isMaintenanceInProgress) {
    return (
      <Suspense fallback={<Loader />}>
        <Maintenance />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<Loader />}>
      <Layout>
        <PagesComponent />
      </Layout>
    </Suspense>
  );
};

export default Pages;
